<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="row m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="row">
            <div class="form-group col-sm-12">
              <ul class="navbar-nav overflow-auto flex-row gap-4">
                <li class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="selectTab(Tabs.list)" 
                     class="nav-link tab" 
                     :class="{'active': activeTabName === Tabs.list}">
                    {{ helper.trans('statistic.requisites.tab.list') }}
                  </a>
                </li>
                <li v-if="isAdmin" class="nav-item nav-item-spaced d-lg-block text-nowrap">
                  <a href="#" @click.prevent="selectTab(Tabs.capacity)" 
                     class="nav-link tab" 
                     :class="{'active': activeTabName === Tabs.capacity}">
                    {{ helper.trans('statistic.requisites.tab.capacity') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTabName === Tabs.list" class="row  m-4 mt-0 mb-0">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">
              <div class="row">

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <TraderMultiselect :multiple="true" v-model="tradersFilter">
                      </TraderMultiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="methods"
                                   class="multiselect-sm"
                                   v-model="requestDTO.methods"
                                   :options="store.getters['currencyMethods/methods']()"
                                   :custom-label="(opt) => helper.trans(`pay_methods.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_methods')"
                      >
                        <template #option="props">
                          <div class="d-flex flex-row align-items-center gap-2">
                            <PayMethodIcon icon-class="icon" :method="props.option"></PayMethodIcon>
                            <span class="overflow-hidden" style="white-space: nowrap; text-overflow: ellipsis">{{ helper.trans('pay_methods.' + props.option) }}</span>
                          </div>
                        </template>
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="options"
                                   class="multiselect-sm"
                                   v-model="requestDTO.options"
                                   :options="store.getters['currencyMethods/options']()"
                                   :custom-label="(opt) => helper.trans(`payment_options.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.payment_options')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="currency"
                                   class="multiselect-sm multiselect-capitalize"
                                   v-model="requestDTO.currency"
                                   :options="store.getters['currencyMethods/currencies']"
                                   :custom-label="(opt) => opt"
                                   :multiple="false"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.currency')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>


                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="form-check small mb-0 mt-1">
                      <input class="form-check-input" v-model="requestDTO.onlyActiveRequisites" type="checkbox" id="onlyActiveRequisites">
                      <label class="form-check-label" for="onlyActiveRequisites">
                        {{ helper.trans('labels.only_active_requisites') }}
                      </label>
                    </div>
                    <div class="form-check small mb-0">
                      <input class="form-check-input" v-model="requestDTO.onlyActiveTraders" type="checkbox" id="onlyActiveTraders">
                      <label class="form-check-label" for="onlyActiveTraders">
                        {{ helper.trans('labels.only_active_traders') }}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div v-if="activeTabName === Tabs.list" class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div class="overflow-auto">
            <table class="table table-bordered align-middle text-left text-nowrap position-relative">
              <thead>
              <tr class="bg-light">
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.payment_method') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'paymentmethod'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'paymentmethod')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.payment_option') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'paymentoption'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'paymentoption')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.total') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'total'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'total')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.traderActive') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'traderactive'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'traderactive')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.deviceOnline') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'deviceonline'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'deviceonline')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.deviceNotBlocked') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'devicenotblocked'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'devicenotblocked')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.min1000') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'min1000'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'min1000')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.min3000') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'min3000'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'min3000')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.min5000') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'min5000'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'min5000')" ></i>
                  </a>
                </th>
                <th class="text-capitalize-first">
                  {{ helper.trans('labels.requisites_summary.inUse') }}
                  <a href="#" @click.prevent="helper.toggleOrderBy(orderByDTO, 'inuse'); ">
                    <i class="fa-solid"  :class="helper.orderByClass(orderByDTO, 'inuse')" ></i>
                  </a>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in sortedItems">
                <td>{{helper.trans(`pay_methods.${item.paymentmethod}`)}}</td>
                <td>{{helper.trans(`payment_options.${item.paymentoption}`)}}</td>
                <td>{{numberFormatter.formatNumber(item.total)}}</td>
                <td>{{numberFormatter.formatNumber(item.traderactive)}}</td>
                <td>{{numberFormatter.formatNumber(item.deviceonline)}}</td>
                <td>{{numberFormatter.formatNumber(item.devicenotblocked)}}</td>
                <td>{{numberFormatter.formatNumber(item.min1000)}}</td>
                <td>{{numberFormatter.formatNumber(item.min3000)}}</td>
                <td>{{numberFormatter.formatNumber(item.min5000)}}</td>
                <td>{{numberFormatter.formatNumber(item.inuse)}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

    <div v-if="activeTabName === Tabs.capacity && isAdmin" class="row m-4 mb-0 mt-0">
      <div class="col-sm-12">
        <div class="card card-body mb-0">
          <div v-if="!capacityData" class="text-center text-muted py-4">
            {{ helper.trans('requisites_capacity.loading') }}
          </div>
          <div class="overflow-auto" v-else-if="capacityData && capacityData.rows && capacityData.rows.length > 0">
              <table class="table table-bordered align-middle text-left text-nowrap position-relative">
                <thead>
                <tr class="bg-light">
                  <th class="text-capitalize-first">
                    {{ helper.trans('requisites_capacity.currency') }}
                    <a href="#" @click.prevent="helper.toggleOrderBy(capacityOrderByDTO, 'currency'); ">
                      <i class="fa-solid"  :class="helper.orderByClass(capacityOrderByDTO, 'currency')" ></i>
                    </a>
                  </th>
                  <th class="text-capitalize-first">
                    {{ helper.trans('labels.payment_option') }}
                    <a href="#" @click.prevent="helper.toggleOrderBy(capacityOrderByDTO, 'paymentOption'); ">
                      <i class="fa-solid"  :class="helper.orderByClass(capacityOrderByDTO, 'paymentOption')" ></i>
                    </a>
                  </th>
                  <th class="text-capitalize-first">
                    {{ helper.trans('requisites_capacity.min_check') }}
                    <a href="#" @click.prevent="helper.toggleOrderBy(capacityOrderByDTO, 'minCheck'); ">
                      <i class="fa-solid"  :class="helper.orderByClass(capacityOrderByDTO, 'minCheck')" ></i>
                    </a>
                  </th>
                  <th class="text-capitalize-first">
                    {{ helper.trans('requisites_capacity.requisites_count') }}
                    <a href="#" @click.prevent="helper.toggleOrderBy(capacityOrderByDTO, 'requisitesCount'); ">
                      <i class="fa-solid"  :class="helper.orderByClass(capacityOrderByDTO, 'requisitesCount')" ></i>
                    </a>
                  </th>
                  <th class="text-capitalize-first">
                    {{ helper.trans('requisites_capacity.liquidity') }}
                    <a href="#" @click.prevent="helper.toggleOrderBy(capacityOrderByDTO, 'liquidity'); ">
                      <i class="fa-solid"  :class="helper.orderByClass(capacityOrderByDTO, 'liquidity')" ></i>
                    </a>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in sortedCapacityItems" :key="index">
                  <td>{{ item.currency }}</td>
                  <td>{{ helper.trans(`payment_options.${item.paymentOption}`) }}</td>
                  <td>{{ numberFormatter.formatNumber(item.minCheck) }}</td>
                  <td>{{ numberFormatter.formatNumber(item.requisitesCount) }}</td>
                  <td>
                    <span :class="{'text-danger': item.liquidity < 0}">
                      {{ numberFormatter.formatNumber(item.liquidity) }}
                    </span>
                  </td>
                </tr>
                </tbody>
              </table>
          </div>
          <div v-else-if="capacityData !== null && (!capacityData.rows || capacityData.rows.length === 0)" class="text-center text-muted py-4">
            {{ helper.trans('requisites_capacity.no_data') }}
          </div>
        </div>
      </div>
    </div>

  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";
import {debounce, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import CopyButton from "@/components/CopyButton.vue";
import {BPagination} from "bootstrap-vue-3";
import {UserRole} from "@/models/enum/UserRole";
import {DealStatus} from "@/models/enum/DealStatus";
import Multiselect from "vue-multiselect";
import moment from "moment";
import OrderByDTO from "@/models/OrderByDTO";
import TraderMultiselect from "@/components/TraderMultiselect.vue";
import PayMethodIcon from "@/components/PayMethodIcon.vue";
import TraderDTO from "@/models/TraderDTO";
import RequisitesCapacityResponseDTO from "@/models/RequisitesCapacityResponseDTO";

const notification = useNotification()

enum Tabs {
  list = 'list',
  capacity = 'capacity'
}

export default defineComponent({
  components: {
    PayMethodIcon,
    TraderMultiselect,
    Multiselect,
    LoaderWrapper,
    CopyButton,
    BPagination,
  },
  setup() {
    const defaultRequestDTO = {
      traderIds: null,
      methods: null,
      options: null,
      currency: 'RUB',
      onlyActiveRequisites: false,
      onlyActiveTraders: false,
    };

    const store = useStore()
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      activeTabName: Tabs.list as Tabs,
      tradersFilter: [] as TraderDTO[],
      orderByDTO: {
        field: 'inuse',
        direction: 'desc'
      } as OrderByDTO,
      capacityOrderByDTO: {
        field: 'liquidity',
        direction: 'desc'
      } as OrderByDTO,
      items: [] as any,
      requestDTO: {
        ...defaultRequestDTO
      } as any,
      capacityData: null as RequisitesCapacityResponseDTO | null
    });

    const selectTab = async (tab: Tabs) => {
      state.activeTabName = tab
      if (tab === Tabs.capacity) {
        await loadCapacity()
      }
    }



    const clearFilters = async () => {
      state.tradersFilter = []
      state.requestDTO = {
        ...defaultRequestDTO
      }
    }

    const load = async () => {
      loader.value?.show()
      try {
        state.requestDTO.traderIds = state.tradersFilter.map((value) => value.id)
        state.items = await api.call.statistic.requisitesSummary(state.requestDTO);

      } finally {
        loader.value?.hide()
      }
    }

    const applyFilters = async () => {
      load()
    }

    const loadCapacity = async () => {
      loader.value?.show()
      try {
        state.capacityData = await api.call.statistic.requisitesCapacity();
      } catch (error) {
        notification.notify({
          type: 'error',
          title: helper.trans('labels.error'),
          text: error instanceof Error ? error.message : String(error)
        });
      } finally {
        loader.value?.hide()
      }
    }

    const sortedItems = computed(() => {
      const sort = state.orderByDTO;

      return [...state.items].sort((a, b) => {
        if (sort.direction === 'asc') {
          return a[sort.field!] > b[sort.field!] ? 1 : -1;
        } else if (sort.direction === 'desc') {
          return a[sort.field!] < b[sort.field!] ? 1 : -1;
        }
        return 0;
      });
    })

    const sortedCapacityItems = computed(() => {
      if (!state.capacityData || !state.capacityData.rows) return [];
      const sort = state.capacityOrderByDTO;

      return [...state.capacityData.rows].sort((a, b) => {
        const aVal = a[sort.field as keyof typeof a];
        const bVal = b[sort.field as keyof typeof b];
        if (sort.direction === 'asc') {
          return aVal > bVal ? 1 : -1;
        } else if (sort.direction === 'desc') {
          return aVal < bVal ? 1 : -1;
        }
        return 0;
      });
    })

    onMounted(() => {
      load()
    });

    return {
      ...toRefs(state),
      user: computed(() => store.getters.getUser),
      isOperator: computed(() => store.getters.isOperator),
      isAdmin: computed(() => store.getters.isAdmin),
      isTrader: computed(() => store.getters.isTrader),
      isTeamLead: computed(() => store.getters.isTeamLead),
      isReferral: computed(() => store.getters.isReferral),
      isMerchant: computed(() => store.getters.isMerchant),
      isMerchantOperator: computed(() => store.getters.isMerchantOperator),
      loader,
      dateHelper,
      numberFormatter,
      helper,
      clearFilters,
      UserRole,
      DealStatus,
      applyFilters,
      store,
      sortedItems,
      sortedCapacityItems,
      Tabs,
      selectTab,
      loadCapacity
    }
  }
})
</script>
